<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Trámites</h4>
    <hr />
    <!-- Instrucciones -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert">
      <strong>Instrucciones:</strong>
      Escriba y presione <kbd>Enter</kbd> en los campos de texto.
      Seleccione una opción en las listas desplegables para filtrar automáticamente.
    </div>

    <!-- Bloque de búsqueda -->
    <div class="container mb-4">
      <div class="row g-3 align-items-end">
        <!-- Número -->
        <div class="col-auto">
          <label class="form-label fw-bold">Número</label>
          <input
            type="text"
            class="form-control"
            v-model="idTramiteBusqueda"
            @keyup.enter="getDataIdTramite(1)"
            placeholder="Ej. 12345"
            style="width: 120px;"
          />
        </div>
        <!-- Estado -->
        <div class="col-auto">
          <label class="form-label fw-bold">Estado</label>
          <select class="form-select" v-model="estadoBusqueda"
            @change="getDataEstado(1)" style="width: 200px;">
            <option value="" disabled selected>Seleccione un estado...</option>
            <option value="REGISTRADO">REGISTRADO</option>
            <option value="CARGADO">CARGADO</option>
            <option value="ESTRUCTURADO">ESTRUCTURADO</option>
            <option value="DOCUMENTADO">DOCUMENTADO</option>
            <option value="ENVIADO">ENVIADO</option>
            <option value="RECIBIDO">RECIBIDO</option>
            <option value="EN PROCESO">EN PROCESO</option>
            <option value="OBSERVACIONES">OBSERVACIONES</option>
            <option value="PLANILLAJE">PLANILLAJE</option>
            <option value="FINALIZADO">FINALIZADO</option>
          </select>
        </div>
        <!-- Botón Todos -->
        <div class="col-auto">
          <button type="button" class="btn btn-outline-primary"
            @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
            <i class="material-icons me-1" style="vertical-align: middle;">auto_awesome_motion</i>
          </button>
        </div>
        <!-- Botón Nuevo -->
        <div class="col-auto">
          <button type="button" class="btn btn-outline-success"
            @click="abrirModalCrear" title="Nuevo registro">
            <i class="material-icons me-1" style="vertical-align: middle;">add_box</i>
            Nuevo registro
          </button>
        </div>
      </div>
    </div>

    <!-- Selector registros por página -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="tramites.length > 0">
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select v-model.number="elementosPorPagina" class="form-select form-select-sm"
        style="width: 75px;" @change="aplicarPaginacion(1)">
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- Tabla -->
    <div class="table-responsive" v-if="tramites.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <tr>
            <th class="th-sort" @click="ordenarPor('idTramite')">
              Número <span>{{ iconOrden('idTramite') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('inicial')">
              Inicial <span>{{ iconOrden('inicial') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('fechaDesde')">
              Fecha desde <span>{{ iconOrden('fechaDesde') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('fechaHasta')">
              Fecha hasta <span>{{ iconOrden('fechaHasta') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('descripcion')">
              Descripción <span>{{ iconOrden('descripcion') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('servicioNombre')">
              Servicio <span>{{ iconOrden('servicioNombre') }}</span>
            </th>
			
            <th class="th-sort" @click="ordenarPor('estadoTramite')">
              Estado <span>{{ iconOrden('estadoTramite') }}</span>
            </th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="tramite in datosPaginados"
            :key="tramite.idTramite"
            @dblclick="handleRowClick($event, tramite.idTramite, tramite.fechaDesde, tramite.fechaHasta)"
            title="Doble clic para ver detalles"
          >
            <td>{{ tramite.idTramite }}</td>
            <td>
              <span v-if="tramite.inicial === 1" class="badge bg-success">Sí</span>
              <span v-else-if="tramite.inicial === 0" class="badge bg-secondary">No</span>
              <span v-else class="badge bg-warning">?</span>
            </td>
            <td>{{ getFormattedDate(tramite.fechaDesde) }}</td>
            <td>{{ getFormattedDate(tramite.fechaHasta) }}</td>
            <td>{{ tramite.descripcion }}</td>
            <td>{{ tramite.servicioNombre }}</td>
            <td>
              <span class="badge" :class="badgeEstado(tramite.estadoTramite)">
                {{ tramite.estadoTramite }}
              </span>
            </td>
            <td>
              <select class="form-select form-select-sm"
                @change="handleAction($event, tramite.idTramite, tramite.fechaDesde, tramite.fechaHasta)">
                <option disabled selected>Seleccione...</option>
                <option value="detalles">Detalles</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="8" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ tramitesOrdenados.length }} trámites
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Sin resultados -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros.
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="tramites.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ tramitesOrdenados.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage()">‹</a>
          </li>
          <li v-for="pagina in paginasVisibles" :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual, disabled: pagina === '...' }">
            <a class="page-link" href="#"
              @click.prevent="pagina !== '...' && aplicarPaginacion(pagina)">
              {{ pagina }}
            </a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage()">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="aplicarPaginacion(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
      aria-labelledby="exampleModalLabel"
      :aria-hidden="isModalOpen ? 'false' : 'true'"
      :inert="!isModalOpen"
      v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size: 24px; color: white;">add_box</span>
            <h5 class="modal-title text-white ms-2" id="exampleModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
              data-bs-dismiss="modal" aria-label="Close"
              @click="isModalOpen = false"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">IdTramite</label></div>
                  <div class="col-4"><span>{{ datoTramite.idTramite }}</span></div>
                  <div class="col-2"><label class="form-label fw-bold">Fecha de registro</label></div>
                  <div class="col-4"><span>{{ formattedFechaReg }}</span></div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Estado</label></div>
                  <div class="col-4">
                    <span class="badge" :class="badgeEstado(datoTramite.estadoTramite)">
                      {{ datoTramite.estadoTramite }}
                    </span>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Prestador</label></div>
                  <div class="col-4"><span>{{ datoTramite.razonSocial }}</span></div>
                </div>
              </div>
              <!-- Servicio -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Servicio</label></div>
                  <div class="col-5">
                    <select class="form-select" v-model="datoTramite.idServicio" required>
                      <option value="" disabled selected>Seleccione el servicio...</option>
                      <option v-for="servicio in servicios" :key="servicio.idServicio"
                        :value="servicio.idServicio">{{ servicio.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2">
                  </div>
                  <div class="col-1">
                    <label class="form-label fw-bold">Inicial</label>
                  </div>
                  <div class="col-2">
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="inicialSwitch"
                        v-model.number="datoTramite.inicial"
                        :true-value="1"
                        :false-value="0"
                        :disabled="btnEditar && !puedeEditarInicial"
                      >
                      <label class="form-check-label" for="inicialSwitch">
                        <span 
                          class="badge ms-2"
                          :class="{
                            'bg-success': datoTramite.inicial === 1,
                            'bg-secondary': datoTramite.inicial === 0,
                            'bg-warning': datoTramite.inicial !== 0 && datoTramite.inicial !== 1
                          }"
                        >
                          {{ datoTramite.inicial === 1 ? 'SÍ – Inicial' : 'NO' }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Asegurador -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Asegurador</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoTramite.idAsegurador" required>
                      <option value="" disabled selected>Seleccione el asegurador...</option>
                      <option v-for="asegurador in aseguradors" :key="asegurador.idAsegurador"
                        :value="asegurador.idAsegurador">{{ asegurador.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Período -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-2"><label class="form-label fw-bold">Período</label></div>
                  <div class="col-3">
                    <select class="form-select" v-model="selectedPeriodo"
                      @change="actualizarPeriodo" required>
                      <option value="" disabled selected>Seleccione el período...</option>
                      <option v-for="periodo in periodos" :key="periodo.value"
                        :value="periodo.value">{{ periodo.text }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Fecha desde</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control"
                      v-model="datoTramite.fechaDesde" disabled />
                  </div>
                  <div class="col-1"><label class="form-label fw-bold">Fecha hasta</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control"
                      v-model="datoTramite.fechaHasta" disabled />
                  </div>
                </div>
              </div>
              <!-- Descripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                  <div class="col-10">
                    <textarea class="form-control" v-model="datoTramite.descripcion"
                      style="text-transform: uppercase;" disabled></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary"
              @click.prevent="guardarAbrirTramite" v-if="btnCrear" title="Guardar">
              <i class="material-icons" style="font-size: 24px; vertical-align: middle;">save</i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { format } from "date-fns";
import * as bootstrap from "bootstrap";
import swal from "sweetalert";

export default {
  components: { Layout, Footer },
  data() {
    return {
      tramites: [],
      datoTramite: {},
      nombreBusqueda: "",
      estadoBusqueda: "",
      aseguradorBusqueda: "",
      idTramiteBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      servicios: [],
      aseguradors: [],
      periodos: [],
      selectedPeriodo: "",
      idTramiteGuardado: 0,
      p_idPrestador: 0,
      idUsuario: 0,
      idEmpresa: 0,
      sinResultados: false,
      isModalOpen: false,
      // Ordenamiento
      campoOrden: 'idTramite',
      ascendente: false,
    };
  },
  computed: {
    formattedFechaReg() {
      if (!this.datoTramite?.fechaReg) return "";
      const d = new Date(this.datoTramite.fechaReg);
      return d instanceof Date && !isNaN(d) ? format(d, "dd-MM-yyyy") : "";
    },
    tramitesOrdenados() {
      const campo = this.campoOrden;
      return [...this.tramites].sort((a, b) => {
        let va = a[campo] ?? '';
        let vb = b[campo] ?? '';
        if (campo === 'idTramite') {
          const na = parseInt(va, 10), nb = parseInt(vb, 10);
          if (!isNaN(na) && !isNaN(nb)) return this.ascendente ? na - nb : nb - na;
        }
        if (campo === 'fechaDesde' || campo === 'fechaHasta') {
          const da = new Date(va), db = new Date(vb);
          if (!isNaN(da) && !isNaN(db)) return this.ascendente ? da - db : db - da;
        }
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },
    paginasVisibles() {
      const total = this.totalPaginas(), actual = this.paginaActual, delta = 2;
      const rango = [];
      for (let i = Math.max(2, actual - delta); i <= Math.min(total - 1, actual + delta); i++) {
        rango.push(i);
      }
      if (rango.length && rango[0] > 2) rango.unshift('...');
      if (rango.length && rango[rango.length - 1] < total - 1) rango.push('...');
      const paginas = [1];
      rango.forEach(p => paginas.push(p));
      if (total > 1) paginas.push(total);
      return paginas;
    },
  },
  mounted() {
    this.idUsuario    = window.sessionStorage.getItem("idUsuario");
    this.idEmpresa    = window.sessionStorage.getItem("idEmpresa");
    this.p_idPrestador = window.sessionStorage.getItem("idPrestador");
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.consultarServicios();
    this.generarPeriodos();
    this.fetchAseguradors();
  },
  methods: {
    // Ordenamiento
    ordenarPor(campo) {
      this.campoOrden = campo === this.campoOrden ? this.campoOrden : campo;
      this.ascendente = campo === this.campoOrden ? !this.ascendente : true;
      this.campoOrden = campo;
      this.aplicarPaginacion(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },
    badgeEstado(estado) {
      return {
        'bg-secondary':         estado === 'REGISTRADO' || estado === 'CARGADO' || estado === 'ESTRUCTURADO' || estado === 'DOCUMENTADO' || estado === 'ENVIADO',
        'bg-primary':           estado === 'RECIBIDO',
        'bg-warning text-dark': estado === 'EN PROCESO' || estado === 'PLANILLAJE',
        'bg-info text-dark':    estado === 'OBSERVACIONES',
        'bg-success':           estado === 'FINALIZADO',
      };
    },
    // Paginación
    totalPaginas() {
      return Math.max(1, Math.ceil(this.tramitesOrdenados.length / this.elementosPorPagina));
    },
    aplicarPaginacion(noPagina) {
      this.paginaActual = noPagina;
      const ini = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginados = this.tramitesOrdenados.slice(ini, ini + this.elementosPorPagina);
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.aplicarPaginacion(this.paginaActual - 1);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.aplicarPaginacion(this.paginaActual + 1);
    },
    // Helpers
    getFormattedDate(date) { return dateFormat.getFormattedDate(date); },
    setPaginacion(data, noPagina) {
      this.tramites = Array.isArray(data) ? data : [];
      this.aplicarPaginacion(noPagina);
      this.sinResultados = this.tramites.length === 0;
    },
    resetearBusquedas(opcion) {
      this.nombreBusqueda    = opcion === "nombre"    ? this.nombreBusqueda    : "";
      this.estadoBusqueda    = opcion === "estado"    ? this.estadoBusqueda    : "";
      this.idTramiteBusqueda = opcion === "idTramite" ? this.idTramiteBusqueda : "";
    },
    handleRowClick(event, idTramite, fechaDesde, fechaHasta) {
      if (event.target.tagName === 'SELECT' || event.target.tagName === 'OPTION') return;
      this.abrirEditar(idTramite, fechaDesde, fechaHasta);
    },
    handleAction(event, idTramite, fechaDesde, fechaHasta) {
      const action = event.target.value;
      if (action === "detalles") this.abrirEditar(idTramite, fechaDesde, fechaHasta);
      else if (action === "anular") this.anularTramite(idTramite);
      event.target.value = "Seleccione...";
    },
    // Datos
    getDataIdTramite(noPagina) {
      if (!this.idTramiteBusqueda) return;
      this.resetearBusquedas("idTramite");
      api.get(`/vwtramites/idempresa-idtramite/${this.idEmpresa}/${this.idTramiteBusqueda}`)
        .then(r => this.setPaginacion(r.data, noPagina));
    },
    getDataEstado(noPagina) {
      if (!this.estadoBusqueda) return;
      this.resetearBusquedas("estado");
      api.get(`/vwtramites/idempresa-estadotramite/${this.idEmpresa}/${this.estadoBusqueda}`)
        .then(r => this.setPaginacion(r.data, noPagina));
    },
    getDataPaginaTodos(noPagina) {
      this.idTramiteBusqueda = "";
      this.estadoBusqueda    = "";
      this.aseguradorBusqueda = "";
      api.get(`/vwtramites/idempresa-idprestador/${this.idEmpresa}/${this.p_idPrestador}`)
        .then(r => this.setPaginacion(r.data, noPagina));
    },
    // Modal y guardado
    validarForm() {
      const fields = ["idPrestador","idServicio","idAsegurador","fechaDesde","fechaHasta","descripcion"];
      const labels = ["idPrestador","Servicio","Asegurador","Fecha Desde","Fecha Hasta","Descripción"];
      return validarForm(this.datoTramite, fields, labels);
    },
    async guardarAbrirTramite() {
      if (this.validarForm() === 1) {
        try {
          this.datoTramite.idUsuarioReg = this.idUsuario;
          this.datoTramite.idEmpresa    = this.idEmpresa;
          const response = await api.post("/tramites/" + this.idUsuario, this.datoTramite);
          this.idTramiteGuardado = response.data.idTramite;
          const modal = bootstrap.Modal.getInstance(document.getElementById('ventanaModal'));
          if (modal) modal.hide();
          this.isModalOpen = false;
          swal("Correcto!", "Tramite creado exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
          await this.abrirEditar(this.idTramiteGuardado);
        } catch (error) {
          swal("Error!", error.response.data.message + " Intentelo de nuevo!", "error");
        }
      }
    },
    abrirModalCrear() {
      this.datoTramite = {
          idPrestador: this.p_idPrestador,
          idServicio: null,
          idAsegurador: 3,
          fechaDesde: null,
          fechaHasta: null,
          descripcion: '',
          inicial: 1,
      };
      this.titulo = "Crear Trámite";
      this.btnCrear = true;
      this.btnEditar = false;
      this.isModalOpen = true;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('ventanaModal'));
        modal.show();
      });
    },
    abrirEditar(idTramite) {
      if (idTramite != null) this.$router.push("/tramiteform-carga/" + idTramite);
    },
    async anularTramite(idTramite) {
      try {
        await api.delete("/tramites/" + idTramite);
        this.getDataPaginaTodos(this.paginaActual);
      } catch { alert("No se pudo eliminar"); }
    },
    consultarServicios() {
      api.get("/vwservicios")
        .then(r => { this.servicios = r.data; })
        .catch(e => console.error("Error fetching servicios:", e));
    },
    generarPeriodos() {
      const meses = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
      const periodos = [];
      const now = new Date();
      for (let i = 0; i < 24; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        const year = d.getFullYear();
        const monthIndex = d.getMonth();
        const monthNumber = String(monthIndex + 1).padStart(2, '0');
        periodos.push({ value: `${year}-${monthNumber}`, text: `${year} - ${meses[monthIndex]}` });
      }
      this.periodos = periodos;
    },
    actualizarPeriodo() {
      if (this.selectedPeriodo) {
        const [year, month] = this.selectedPeriodo.split("-").map(Number);
        const meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
        this.datoTramite.fechaDesde = new Date(year, month - 1, 1).toISOString().substr(0, 10);
        this.datoTramite.fechaHasta = new Date(year, month, 0).toISOString().substr(0, 10);
        this.datoTramite.descripcion = `ATENCIONES DE ${meses[month - 1].toUpperCase()} ${year}`;
      }
    },
    fetchAseguradors() {
      api.get('/vwaseguradors/estado/1')
        .then(r => { this.aseguradors = r.data; })
        .catch(e => console.error('Error fetching aseguradors:', e));
    },
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
</style>